import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

/**
 * Schema for resource summary data displayed on index/listing pages.
 * This is the summarized representation of a resource shown in cards,
 * as opposed to the full resource details shown on individual pages.
 */
export const ResourceSummarySchema = z.object({
  heading: z.string().optional(),
  image: z
    .object({
      description: z.string().optional(),
      url: z.string().optional(),
    })
    .optional(),
  path: z.string().optional(),
  description: RichTextSchema.optional(),
})

export type ResourceSummary = z.infer<typeof ResourceSummarySchema>
